import { IUserStore, IUserStoreToken } from '../state/users/user.store';

import { SessionStateService } from '@abp/ng.core';
import { Inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfigStateService } from './config-state.service';

@Injectable({
  providedIn: 'root',
})
export class OdysseyLanguageService {
  constructor(
    private sessionState: SessionStateService,
    @Inject(IUserStoreToken) private userService: IUserStore,
    private configState: ConfigStateService,
  ) {
    this.sessionState
      .onLanguageChange$()
      .pipe(takeUntilDestroyed())
      .subscribe(newLang => {
        this.configState.isAuthenticated$.subscribeOnce(isAuthenticated => {
          if (isAuthenticated) this.userService.setLanguageCulture(newLang).subscribeOnce();
        });
      });
  }
}
